export const typeConsts = {
  SM: 'SM',
  LG: 'LG',
  FORM: 'FORM',
} as const;

export const widthConsts = {
  NARROW: 'NARROW',
  WIDE: 'WIDE',
  FIT: 'FIT',
} as const;

export const widths: Record<string, string> = {
  [widthConsts.NARROW]: '65px',
  [widthConsts.WIDE]: '300px',
  [widthConsts.FIT]: 'auto',
};
